import React, { useEffect, useState, useCallback } from 'react';
import { useTranslate } from '../../../components/TranslationText';
import DecisionFilter from '../Components/DecisionFilter';
import DecisionCard from '../Components/DecisionCard';
import { filterDecisions } from '../Api/disciplinaryDecisionsApi';
import ActionButton from '../../../components/ActionButton';

const TAKE = 10;

const initialFilters = {
    search: '',
    reason: 'All Reasons',
    year: 'All Years',
    skip: 0,
    take: TAKE,
};

export default function DisciplinaryDecisionsListPage() {
    const { translate } = useTranslate();
    const [filters, setFilters] = useState(initialFilters);
    const [decisions, setDecisions] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const hasMore = decisions.length < totalCount;

    const fetchList = useCallback(async (newFilters, append = false) => {
        setLoading(true);
        try {
            const res = await filterDecisions(newFilters);
            setTotalCount(res?.totalCount || 0);
            setDecisions(prev =>
                append ? [...prev, ...(res?.result ?? [])] : res?.result ?? []
            );
        } catch (error) {
            console.error("Error fetching decisions:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchList(initialFilters);
    }, [fetchList]);

    const handleFilter = (filterArgs) => {
        const newFilters = {
            ...filters,
            ...filterArgs,
            skip: 0,
        };

        setFilters(newFilters);
        fetchList(newFilters);
    };

    const handleLoadMore = () => {
        const newFilters = {
            ...filters,
            skip: filters.skip + filters.take,
        };

        setFilters(newFilters);
        fetchList(newFilters, true);
    };

    return (
        <div className="container pt-3 pb-5">
            <div className="row mb-4">
                <div className="col-12">
                    <h1 className="fw-bold mb-2 text-dark" style={{ fontSize: '2.5rem' }}>
                        {translate('web.disciplinaryDecisions', 'Disciplinary Decisions')}
                    </h1>
                </div>
            </div>

            <div className="row mb-4">
                <div className="col-12">
                    <DecisionFilter submit={handleFilter} />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    {loading && decisions.length === 0 ? (
                        <div className="d-flex justify-content-center py-5">
                            <div className="spinner-border text-danger" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : decisions.length > 0 ? (
                        decisions.map(item => (
                            <DecisionCard key={item.id} decision={item} />
                        ))
                    ) : (
                        <div className="text-center py-5 text-muted">
                            <i className="fa-solid fa-folder-open mb-3" style={{ fontSize: '3rem', color: '#ccc' }}></i>
                            <h5>{translate('web.noDecisionsFound', 'No decisions found')}</h5>
                            <p>{translate('web.tryAdjustingFilters', 'Try adjusting your filters to find what you are looking for.')}</p>
                        </div>
                    )}
                </div>

                {hasMore && !loading && (
                    <div className="col-12 mt-4 text-center">
                        <ActionButton
                            label={translate('web.loadMore', 'Load More')}
                            type="loadmore"
                            onClick={handleLoadMore}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
